"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudFile = void 0;
const Common_1 = require("./Common");
const Base_1 = require("./Base");
const index_1 = require("../index");
class CloudFile extends Base_1.Base {
    name = '';
    type = '';
    url = '';
    lastModified = null;
    size = null;
    third_party = '';
    locked = false;
    metadata = {};
    constructor(data, olMap) {
        super('files', 10);
        (0, Common_1.setObjectProperties)(this, data, olMap, CloudFile);
        if (!this.date) {
            this.date = this.lastModified || Date.now();
        }
    }
    toJSON() {
        let r = super.toJSON();
        if (!r.date) {
            r.date = r.lastModified || Date.now();
        }
        return r;
    }
}
exports.CloudFile = CloudFile;
index_1.olm.files = (ref, map) => {
    return new CloudFile(ref, map);
};
